import React, { Component } from "react";
import Header from "./TableHeader";
import TableData from "./TableData";
import { Pagination, Row, Col, Spin } from "antd";
import { connect } from "react-redux";
import { fetchLoadData, unsubscribe } from "../../store/actions/webService";
import "./ProviderTable.css";
import Config from "../../config";
import download from "../images/download.png";
import moment from "moment";
import ExportJsonExcel from "js-export-excel";
import globalSearch from "../images/GlobalSearch.svg";
import blackscreen from "../images/emptysearchscreen.svg";

class ClaimsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      componentKey: 1,
      External: false,
      SearchExternal: false,
      displayErrormessage:false,
      allRows: [],
      curRows: [],
      currentPage: 1,
      rowsPerPage: 15,
      totalRowCount: 0,
      totalPages:0,
      Dummytable: [],
      SortTable: [],
      filterdata: [],
      MessageForClaims: "",
      updatetable: false,
      tablestate: false,
      sortedData: [],
      TextValue: "ClaimsTable",
      newpagevalue: false,
      currentPage: 1,
      changepagesize: false,
      loader: true,

      fetchedTotalRecords:0,
      printclaimsloading:false,

      filter: {
        Claims: "",
        BillingProviderName: "",
        Tax: "",
        RenderingNPI: "",
        BillingNPI: "",
        ProviderName: "",
        SubID: "",
        SubName: "",
        PatientName: "",
        DOSFrom: "",
        DOSTo: "",
        PlanCode: "",
        PaidOn: "",
        NetPayAmt: "",
        PayAmt: "",
        ClaimStatus: "",
        ClaimStatus2: "",
        Age: "",
        PlanName: "",
        ClaimType: "",
        PlanRecievedDate: "",
        IsCorrectedClaim: ""
      },
      abortController: new AbortController(), // Initialize AbortController
      headers:[
        {
          "title": "claimNumber",
          "displayName": "Claim Number",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "billingProviderName",
          "displayName": "Billing Provider",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "taxid",
          "displayName": "Tax ID",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "renderingNPI",
          "displayName": "Rendering NPI",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "billingNPI",
          "displayName": "Billing NPI",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "pcpNPI",
          "displayName": "NPI",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "providerName",
          "displayName": "Rendering Provider",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "subscribeID",
          "displayName": "Sub ID",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "subscriberName",
          "displayName": "Subs. Name",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "patientName",
          "displayName": "Member Name",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "dosFromDate",
          "displayName": "DOS From",
          "display": true,
          "filterType": "date"
        },
        {
          "title": "dosToDate",
          "displayName": "DOS To",
          "display": true,
          "filterType": "date"
        },
        {
          "title": "planCode",
          "displayName": "Plan Code",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "paidOn",
          "displayName": "Paid On",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "totalNetPaymentAmt",
          "displayName": "Net Pay Amt ($)",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "totalPaymentAmount",
          "displayName": "Total Charges($)",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "claimStatus",
          "displayName": "Claim Stage",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "age",
          "displayName": "Age",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "planName",
          "displayName": "Plan Name",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "claimType",
          "displayName": "Claim Type",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "planReceivedDate",
          "displayName": "Plan Recieve Date",
          "display": false,
          "filterType": "date"
        },
        {
          "title": "uniqueMemberID",
          "displayName": "UniqueMemberID",
          "display": false,
          "filterType": "text"
        },
        {
          "title": "claimStatus2",
          "displayName": "Claim Status",
          "display": true,
          "filterType": "text"
        },
        {
          "title": "isCorrectedClaim",
          "displayName": "Claim Submission",
          "display": true,
          "filterType": "text"
        }
        
    ],
      sort: {
        column: null,
        direction: "asc",
      },
    };
  }

  componentDidMount() {
    if (this.props.claimsData) {
      const data = this.props.claimsData.claimsDetails
      this.setState({
        headers: Object.keys(data[0]).map((key) => {
          
          return {
            title: key,
            displayName: Config.tableColumns[key].displayName,
            display:
              Config.tableColumns &&
                Config.tableColumns[key] &&
                Config.tableColumns[key].display
                ? true
                : false,
            filterType: Config.tableColumns[key].filterType || "text",
          };
        }),
        Dummytable: [...data],
        filterdata: [...data],
        loader: false,
        SearchExternal:true,
        isLoading: false,
        totalPages: this.props.claimsData.TotalRecords,
      })
    }
    else{
     // this.getClaimsData("UL0005394");
    }
  }


  addZeroes = (num) => {
    var value = Number(num);
    var res = num.split(".");
    if (res.length == 1 || res[1].length < 3) {
      value = value.toFixed(2);
    }
    return value;
  }


 printClaimList = (tableData = null) => {
  this.setState({
    printclaimsloading:false
  })
    const dataToExport = tableData || this.state.Dummytable || [];
    if (!dataToExport.length) {
        alert("No data available to export.");
        return;

    }

    const renderRowsTable = dataToExport.map(row => ({
        claimNumber: row.claimNumber || "------",
        billingProviderName: row.billingProviderName || "------",
        taxid: row.taxid || "------",
        renderingNPI: row.renderingNPI || "------",
        billingNPI: row.billingNPI || "------",
        providerName: row.providerName || "------",
        subscribeID: row.subscribeID || "------",
        patientName: row.patientName || "------",
        dosFromDate: row.dosFromDate ? moment(row.dosFromDate).format("MMM DD, YYYY") : "------",
        dosToDate: row.dosToDate ? moment(row.dosToDate).format("MMM DD, YYYY") : "------",
        totalNetPaymentAmt: row.totalNetPaymentAmt != null ? row.totalNetPaymentAmt : "$ 0.00",
        totalPaymentAmount: row.totalPaymentAmount != null 
            ? "$ " + this.addZeroes(`${row.totalPaymentAmount}`) 
            : "$ 0.00",

        claimStatus: row.claimStatus || "------",
        claimType: row.claimType || "------",
        claimStatus2: row.claimStatus2 || "------",
        claimSubmission:row.isCorrectedClaim === true ? "CORRECTED" : row.isCorrectedClaim === false ? "NEW" : "------"
    }));

    
    const option = {
        fileName: "Claim Search List",
        datas: [

            {
                sheetData: renderRowsTable,
                sheetName: "Claim Search List",
                sheetHeader: [
                    "Claim Number",
                    "Billing Provider",
                    "Tax ID",
                    "Rendering NPI",
                    "Billing NPI",
                    "Rendering Provider",
                    "Sub ID",
                    "Member Name",
                    "DOS From",
                    "DOS To",
                    "Net Pay Amt ($)",
                    "Total Charges ($)",
                    "Claim Stage",
                    "Claim Type",
                    "Claim Status",
            "Claim Submission"
          ]
        }
      ]
    };
    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    
  };


  getClaimsData = async () => {
    // Abort any previous API request
    if (this.state.abortController) {
        this.state.abortController.abort();
    }

    // Create a new AbortController for this request
    const newAbortController = new AbortController();
    this.setState({ abortController: newAbortController });

    this.setState({
        isLoading: true,
        Dummytable: [],
        displayErrormessage: false,
    });

    try {
        let userNPI = sessionStorage.getItem("npivalue");
        let userTaxId = sessionStorage.getItem("taxid");
        let taxidNpiMapping = sessionStorage.getItem("rolename").includes("IPA User")
            ? sessionStorage.getItem("latestTaxidNpiMapping")
            : sessionStorage.getItem("taxidNpiMapping");

        let taxIDMapping = [];
        if (taxidNpiMapping) {
            for (let item of JSON.parse(taxidNpiMapping)) {
                taxIDMapping.push({
                  billingProvider_Tax_ID: item.TaxID ? item.TaxID : "",
                    npi: item.NPI
                });
            }
        }

        let taxMapping = [];
        if (userNPI || userTaxId) {
            taxMapping = [{
                billingProvider_Tax_ID: userTaxId ? JSON.parse(userTaxId)[0].toString() : "",
                npi: userNPI ? JSON.parse(userNPI) : []
            }];
        }

        let filter = this.state.filter;
        let subscriberID = this.props.fromPage === "Member Search" 
            ? this.props.MemberId 
            : filter.SubID ? filter.SubID : null;

        let response = await fetch(Config.api + "/GetClaimDeatils", {
            method: "POST",
            headers: {
                Authorization: sessionStorage.getItem("access_token"),
                Accept: "application/json",
                "Content-type": "application/json",
            },
            signal: newAbortController.signal, // Attach AbortController signal
            body: JSON.stringify({
                planName: sessionStorage.getItem("planName"),
                isDSNP: sessionStorage.getItem("IsDSNP") === "1" ? true : false,
                claimNumber: filter.Claims || null,
                billingProviderFullName: filter.BillingProviderName || null,
                taxidNPIs: taxIDMapping.length > 0 ? taxIDMapping : taxMapping,
                renderingNPI: filter.RenderingNPI || "", 
                billingNPI:filter.BillingNPI ||  "",   
                billingProvider_Tax_ID: filter.Tax || null,
                subscriber_ID: subscriberID,
                memberFullName: filter.PatientName || null,
                providerFullName: filter.ProviderName || null,
                dosFromDate: filter.DOSFrom || null,
                dosToDate: filter.DOSTo || null,
                totalNetPaymentAmt: filter.NetPayAmt || null,
                totalCharges: filter.PayAmt || null,
                claimStatus: filter.ClaimStatus || null,
                claimType: filter.ClaimType || null,
                claimStatus2: filter.ClaimStatus2 || null,
                pageSize: 15,
                pageNumber: this.state.currentPage,
                isCorrectedClaim: filter.IsCorrectedClaim
                    ? 'CORRECTED'.includes(filter.IsCorrectedClaim.toUpperCase()) ? true
                    : 'NEW'.includes(filter.IsCorrectedClaim.toUpperCase()) ? false
                    : null
                    : null
            }),
        });

        let data = await response.json();
        this.setState({ fetchedTotalRecords: data.TotalRecords });
        console.log("data",data)
      if (data.claimsDetails && data.claimsDetails.length > 0) {
        // Move billingNPI and renderingNPI after pcpNPI
        data.claimsDetails = data.claimsDetails.map(obj => {
          // Destructure out the fields to move
          const { renderingNPI, billingNPI, ...rest } = obj;

          const newObj = {};
          for (const key in rest) {
            newObj[key] = rest[key];

            // After inserting pcpNPI, insert the moved fields
            if (key === "pcpNPI") {
              newObj.renderingNPI = renderingNPI;
              newObj.billingNPI = billingNPI;

            }
          }
          return newObj;
        });
      }

         //console.log(testdata)
       // 
        
        if (data.claimsDetails && data.claimsDetails.length > 0) {
            this.setState({
                headers: Object.keys(data.claimsDetails[0]).map((key) => ({
                    title: key,
                    displayName: Config.tableColumns[key]?.displayName,
                    display: Config.tableColumns[key]?.display || false,
                    filterType: Config.tableColumns[key]?.filterType || "text",
                })),
                totalPages: data.TotalRecords,
                Dummytable: data.claimsDetails.map(ele => ({
                    ...ele,
                    isCorrectedClaim: ele.isCorrectedClaim === true ? "Corrected" 
                        : ele.isCorrectedClaim === false ? "New" 
                        : "---"
                })),
                filterdata: data.claimsDetails.map(ele => ({
                    ...ele,
                    isCorrectedClaim: ele.isCorrectedClaim === true ? "Corrected" 
                        : ele.isCorrectedClaim === false ? "New" 
                        : "---"
                })),
                isLoading: false,
                MessageForClaims: data.Message,
            });
            console.log("Dummytable",this.state.Dummytable)
            console.log(this.state.headers)
           

        } else {
            this.setState({
                displayErrormessage: true,
                isLoading: false,
                MessageForClaims: data.Message,
            });
        }
    } catch (error) {
        if (error.name === "AbortError") {
            console.log("API call aborted");
        } else {
            console.error("API request failed:", error);
        }
        this.setState({ isLoading: false });
    }


        

        
          
      

};

  fetchAllClaims = async () => {
    try {
      const allClaims = [];
      let pageNumber = 1;
      const pageSize = this.props.fetchedTotalRecords
                        ? this.props.fetchedTotalRecords
                        : this.state.fetchedTotalRecords
                          ? this.state.fetchedTotalRecords
                          : null;
      let totalRecords = 0;

        let userNPI = sessionStorage.getItem("npivalue");
        let userTaxId = sessionStorage.getItem("taxid");
        let taxidNpiMapping = sessionStorage.getItem("rolename").includes("IPA User")
          ? sessionStorage.getItem("latestTaxidNpiMapping")
          : sessionStorage.getItem("taxidNpiMapping");

        let taxIDMapping = [];
        if (taxidNpiMapping) {
          for (let item of JSON.parse(taxidNpiMapping)) {
            taxIDMapping.push({
              billingProvider_Tax_ID: item.TaxID,
              npi: item.NPI
            });
          }
        }

        let taxMapping = [];
        if (userNPI || userTaxId) {
          taxMapping = [{
            billingProvider_Tax_ID: userTaxId ? JSON.parse(userTaxId)[0].toString() : null,
            npi: userNPI ? [JSON.parse(userNPI)] : []
          }];
        }
        let filter = this.state.filter;
        let subscriberID = this.props.MemberId
          ? this.props.MemberId
          : filter.SubID ? filter.SubID : null;

        const response = await fetch(Config.api + "/GetClaimDeatils", {
          method: "POST",
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            planName: sessionStorage.getItem("planName"),
            claimNumber: filter.Claims || null,
            billingProviderFullName: filter.BillingProviderName || null,
            taxidNPIs: taxIDMapping.length > 0 ? taxIDMapping : taxMapping,// You can move taxIDMapping logic into a helper function
            renderingNPI: filter.RenderingNPI || "",
            billingNPI:filter.BillingNPI ||  "",
            billingProvider_Tax_ID: filter.Tax || null,
            subscriber_ID: subscriberID,
            memberFullName: filter.PatientName || null,
            providerFullName: filter.ProviderName || null,
            dosFromDate: filter.DOSFrom || null,
            dosToDate: filter.DOSTo || null,
            totalNetPaymentAmt: filter.NetPayAmt || null,
            totalCharges: filter.PayAmt || null,
            claimStatus: filter.ClaimStatus || null,
            claimType: filter.ClaimType || null,
            claimStatus2: filter.ClaimStatus2 || null,
            pageSize: pageSize,
            pageNumber: pageNumber,
            isCorrectedClaim: filter.IsCorrectedClaim
              ? 'CORRECTED'.includes(filter.IsCorrectedClaim.toUpperCase()) ? true
                : 'NEW'.includes(filter.IsCorrectedClaim.toUpperCase()) ? false
                  : null
              : null
          }),
        });

        const data = await response.json();
         return data.claimsDetails || [];
    } catch (error) {
      console.error("Failed to fetch all claims:", error);
      return [];
    }
  };

exportAllClaims = async () => {
  this.setState({
    printclaimsloading:true
  })
    const allClaims = await this.fetchAllClaims();
    if (allClaims.length === 0) {
        alert("No claims available to export.");
        return;
    }
    this.printClaimList(allClaims); 

};

 

  onPageChange = (page, pageSize) => {
    this.setState({ currentPage: page }, () => {
      // Now currentPage is updated, and we can call getClaimsData
      this.getClaimsData(this.state.currentPage);
    });
  };

  //.............................Changing data based on page change load.......................
  getpaginationData = (allRows, currentPage) => {
    const indexOfLastRow = currentPage * this.state.rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - this.state.rowsPerPage;
    const currentPageData = allRows.slice(indexOfFirstRow, indexOfLastRow);
    return currentPageData;
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  handleShow = () => {
    this.setState({ show: true });
  };

  // sorting table data for each column................
  tableSortresult = (column) => {
    const direction = this.state.sort.direction === "desc" ? "asc" : "desc";
    const sortedData = this.state.Dummytable.sort((a, b) => {
      if (
        column === "claimNumber" ||
        column === "patientName" ||
        column === "subscribeID" ||
        column === "dosFromDate" ||
        column === "dosToDate" ||
        column === "claimStatus" ||
        column === "billingProviderName" ||
        column === "providerName" ||
        column === "renderingNPI" ||
        column === "billingNPI" ||
        column === "totalPaymentAmount" ||
        column === "totalNetPaymentAmt" ||
        column === "claimType" ||
        column === "isCorrectedClaim"
      ) {
        const nameA =
          // column === "SubscriberID"? a.SubscriberID.toUpperCase()
          column === "claimNumber"
            ? a.claimNumber === null
              ? ""
              : a.claimNumber.toUpperCase()
            : column === "isCorrectedClaim"
              ? a.isCorrectedClaim === "---"
                ? ""
                : a.isCorrectedClaim.toUpperCase()
            : column === "patientName"
              ? a.patientName === null
                ? ""
                : a.patientName.toUpperCase()
              : column === "subscribeID"
                ? a.subscribeID === null
                  ? ""
                  : a.subscribeID.toUpperCase()
                : column === "dosFromDate"
                  ? a.dosFromDate === null
                    ? ""
                    : new Date(a.dosFromDate)
                  : column === "dosToDate"
                    ? a.dosToDate === null
                      ? ""
                      : new Date(a.dosToDate)
                    : column === "claimStatus"
                      ? a.claimStatus === null
                        ? ""
                        : a.claimStatus.toUpperCase()
                        : column === "claimStatus2"
                        ? b.claimStatus2 === null
                          ? ""
                          : b.claimStatus2.toUpperCase()
                      : column === "billingProviderName"
                        ? a.billingProviderName === null
                          ? ""
                          : b.claimStatus2.toUpperCase()
                        : column === "billingProviderName"
                          ? a.billingProviderName === null
                            ? ""
                            : a.billingProviderName.toUpperCase()
                          : column === "providerName"
                            ? a.providerName === null
                              ? ""
                              : a.providerName.toUpperCase()
                             : column === "renderingNPI" ? a.renderingNPI === null ? "": a.renderingNPI.toUpperCase()
                             : column === "billingNPI" ? a.billingNPI === null ? "": a.billingNPI.toUpperCase()
                              : column === "totalPaymentAmount"
                                ? a.totalPaymentAmount === null || a.totalPaymentAmount === ""
                                  ? -99999999
                                  : parseInt(a.totalPaymentAmount)
                                : column === "totalNetPaymentAmt"
                                  ? a.totalNetPaymentAmt === null || a.totalNetPaymentAmt === ""
                                    ? -99999999
                                    : parseInt(a.totalNetPaymentAmt)
                                  : a.claimType === null
                                    ? ""
                                    : a.claimType.toUpperCase();
        const nameB =
          column === "claimNumber"
            ? b.claimNumber === null
              ? ""
              : b.claimNumber.toUpperCase()
            : column === "isCorrectedClaim"
              ? b.isCorrectedClaim === "---"
                ? ""
                : b.isCorrectedClaim.toUpperCase()
            : column === "patientName"
              ? b.patientName === null
                ? ""
                : b.patientName.toUpperCase()
              : column === "subscribeID"
                ? b.subscribeID === null
                  ? ""
                  : b.subscribeID.toUpperCase()
                : column === "dosFromDate"
                  ? b.dosFromDate === null
                    ? ""
                    : new Date(b.dosFromDate)
                  : column === "dosToDate"
                    ? b.dosToDate === null
                      ? ""
                      : new Date(b.dosToDate)
                    : column === "claimStatus"
                      ? b.claimStatus === null
                        ? ""
                        : b.claimStatus.toUpperCase()
                        : column === "claimStatus2"
                        ? b.claimStatus2 === null
                          ? ""
                          : b.claimStatus2.toUpperCase()
                      : column === "billingProviderName"
                        ? b.billingProviderName === null
                          ? ""
                          : b.billingProviderName.toUpperCase()
                        : column === "providerName"
                          ? b.providerName === null
                            ? ""
                            : b.providerName.toUpperCase()
                          : column === "renderingNPI"
                            ? b.renderingNPI === null
                              ? ""
                              : b.renderingNPI.toUpperCase()

                              : column === "billingNPI"
                            ? b.billingNPI === null
                              ? ""
                              : b.billingNPI.toUpperCase()

                            : column === "totalPaymentAmount"
                              ? b.totalPaymentAmount === null || b.totalPaymentAmount === ""
                                ? -99999999
                                : parseInt(b.totalPaymentAmount)
                              : column === "totalNetPaymentAmt"
                                ? b.totalNetPaymentAmt === null || b.totalNetPaymentAmt === ""
                                  ? -99999999
                                  : parseInt(b.totalNetPaymentAmt)
                                : b.claimType === null
                                  ? ""
                                  : b.claimType.toUpperCase();

        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      } else {
        return a.column - b.column;
      }
    });

    if (direction === "asc") {
      sortedData.reverse();
    }

    this.setState({
      filterdata: sortedData,
      tablestate: true,
      sort: {
        column,
        direction,
      },
    });
  };

  getGlobalClaims = () => {
    
    this.setState({
        SearchExternal: true,
        currentPage: 1
      },
      () => {
        this.getClaimsData();       // call after state is updated
      }
    );
  };


  resetFilter = () => {
    console.log("this.props.claimsData", this.props.claimsData);

    // Cancel the API call if it's in progress
    if (this.state.abortController) {
        this.state.abortController.abort();
        console.log("Ongoing API call aborted.");
    }

    // Check if any filters are applied
    let filtersApplied = Object.values(this.state.filter).some(value => value !== "");
    console.log("Filters Applied:", filtersApplied);

    // Reset all filter values
    Object.keys(this.state.filter).forEach(item => {
        this.state.filter[item] = "";
    });

    if (this.props.claimsData) {
        this.setState({
            filterdata: [],
            totalPages: 0,
            currentPage: 1,
            displayErrormessage: false,
            isLoading: false,
            abortController: new AbortController() // Create a new AbortController for next request
        });

        // Only call API if filters were previously applied
        if (filtersApplied) {
          console.log("sdfsadfasdasdas")
          this.setState({
            componentKey: this.state.componentKey + 1,
            tablestate: false,
            Dummytable: [],
            filterdata: [],
            totalPages: 0,
            currentPage: 1,
            External: false,
            isLoading: false,
            abortController: new AbortController() // Reset AbortController
        });
            this.getClaimsData();
        }
    } else {
        this.setState({
            componentKey: this.state.componentKey + 1,
            tablestate: false,
            Dummytable: [],
            filterdata: [],
            totalPages: 0,
            currentPage: 1,
            SearchExternal: false,
            displayErrormessage: false,
            External: false,
            isLoading: false,
            abortController: new AbortController() // Reset AbortController
        });
    }
};

  // filtering table value based on textbox value
  filters = (fname, value) => {
    if (fname === "claimNumber") {
      this.state.filter.Claims = value;
    } else if (fname === "billingProviderName") {
      this.state.filter.BillingProviderName = value;
    } else if (fname === "taxid") {
      this.state.filter.Tax = value;
    } else if (fname === "renderingNPI") {
      this.state.filter.RenderingNPI = value;
    } else if (fname === "billingNPI") {
      this.state.filter.BillingNPI = value;
    } else if (fname === "providerName") {
      this.state.filter.ProviderName = value;
    } else if (fname === "subscribeID") {
      this.state.filter.SubID = value;
    } else if (fname === "subscriberName") {
      this.state.filter.SubName = value;
    } else if (fname === "patientName") {
      this.state.filter.PatientName = value;
    } else if (fname === "dosFromDate") {
      this.state.filter.DOSFrom = value;
    } else if (fname === "dosToDate") {
      this.state.filter.DOSTo = value;
    } else if (fname === "planCode") {
      this.state.filter.PlanCode = value;
    } else if (fname === "paidOn") {
      this.state.filter.PaidOn = value;
    } else if (fname === "totalNetPaymentAmt") {
      this.state.filter.NetPayAmt = value;
    } else if (fname === "totalPaymentAmount") {
      this.state.filter.PayAmt = value;
    } else if (fname === "claimStatus") {
      this.state.filter.ClaimStatus = value;
    } else if (fname === "claimStatus2") {
      this.state.filter.ClaimStatus2 = value;
    } else if (fname === "age") {
      this.state.filter.Age = value;
    } else if (fname === "planName") {
      this.state.filter.PlanName = value;
    } else if (fname === "claimType") {
      this.state.filter.ClaimType = value;
    } else if (fname === "planReceivedDate") {
      this.state.filter.PlanRecievedDate = value;
    }else if (fname === "isCorrectedClaim") {
      this.state.filter.IsCorrectedClaim = value;
    }

    // Filtering table based on input data.......................

    this.state.filterdata = this.state.Dummytable.filter((e) => {
      // e.totalNetPaymentAmt =
      //   e.totalNetPaymentAmt === null ? "" : e.totalNetPaymentAmt.toString();
      //  totalNetPaymentAmt;
      e.totalNetPaymentAmt =
        e.totalNetPaymentAmt === null
          ? ""
          : e.totalNetPaymentAmt === ""
            ? ""
            : parseFloat(e.totalNetPaymentAmt).toFixed(2);
      // e.totalNetPaymentAmt.toString();

      e.totalPaymentAmount =
        e.totalPaymentAmount === null
          ? ""
          : e.totalPaymentAmount === ""
            ? ""
            : parseFloat(e.totalPaymentAmount).toFixed(2);
      // e.totalPaymentAmount.toString();
      // e.paidOn = e.paidOn === null ? "" : e.paidOn;
      e.billingProviderName =
        e.billingProviderName === null ? "" : e.billingProviderName;
      e.claimStatus = e.claimStatus === null ? "" : e.claimStatus;
      e.claimStatus2 = e.claimStatus2 === null ? "" : e.claimStatus2;
      e.taxid = e.taxid === null ? "" : e.taxid;
      e.renderingNPI = e.renderingNPI === null ? "" : e.renderingNPI;
      e.billingNPI = e.billingNPI === null ? "" : e.billingNPI;
      e.providerName = e.providerName === null ? "" : e.providerName;
      e.subscribeID = e.subscribeID === null ? "" : e.subscribeID;
      // e.subscriberName = e.subscriberName === null ? "" : e.subscriberName;
      e.claimNumber = e.claimNumber === null ? "" : e.claimNumber;
      e.patientName = e.patientName === null ? "" : e.patientName;
      e.dosFromDate = e.dosFromDate === null ? "" : e.dosFromDate;
      e.dosToDate = e.dosToDate === null ? "" : e.dosToDate;
      // e.planCode = e.planCode === null ? "" : e.planCode;
      e.claimType = e.claimType === null ? "" : e.claimType;
     // e.isCorrectedClaim = e.isCorrectedClaim === null ? "" : e.isCorrectedClaim;
     e.isCorrectedClaim = e.isCorrectedClaim === null ? "" : e.isCorrectedClaim.toString();

      return (
        e.claimNumber
          .toLowerCase()
          .includes(this.state.filter.Claims.toLowerCase()) &&
        e.billingProviderName
          .toLowerCase()
          .includes(this.state.filter.BillingProviderName.toLowerCase()) &&
        e.taxid.toLowerCase().includes(this.state.filter.Tax.toLowerCase()) &&
        e.renderingNPI
          .toLowerCase()
          .includes(this.state.filter.RenderingNPI.toLowerCase()) &&
          e.billingNPI
          .toLowerCase()
          .includes(this.state.filter.BillingNPI.toLowerCase()) &&
        e.providerName
          .toLowerCase()
          .includes(this.state.filter.ProviderName.toLowerCase()) &&
        e.subscribeID
          .toLowerCase()
          .includes(this.state.filter.SubID.toLowerCase()) &&
        // e.subscriberName
        //   .toLowerCase()
        //   .includes(this.state.filter.SubName.toLowerCase()) &&
        e.patientName
          .toLowerCase()
          .includes(this.state.filter.PatientName.toLowerCase()) &&
        e.dosFromDate
          .toLowerCase()
          .includes(this.state.filter.DOSFrom.toLowerCase()) &&
        e.dosToDate.toLowerCase().includes(this.state.filter.DOSTo) &&
        // e.planCode
        //   .toLowerCase()
        //   .includes(this.state.filter.PlanCode.toLowerCase()) &&
        // e.paidOn.toLowerCase().includes(this.state.filter.PaidOn) &&
        e.totalNetPaymentAmt.includes(this.state.filter.NetPayAmt) &&
        e.totalPaymentAmount.includes(this.state.filter.PayAmt) &&
        e.claimStatus
          .toLowerCase()
          .includes(this.state.filter.ClaimStatus.toLowerCase()) &&
          e.claimStatus2
          .toLowerCase()
          .includes(this.state.filter.ClaimStatus2.toLowerCase()) &&
        // e.age.toLowerCase().includes(this.state.filter.Age.toLowerCase()) &&
        // e.planName
        //   .toLowerCase()
        //   .includes(this.state.filter.PlanName.toLowerCase()) &&
        e.claimType
          .toLowerCase()
          .includes(this.state.filter.ClaimType.toLowerCase()) &&
        e.isCorrectedClaim
          .toLowerCase()
          .includes(this.state.filter.IsCorrectedClaim.toLowerCase()) 
        // &&
        // e.planReceivedDate
        //   .toLowerCase()
        //   .includes(this.state.filter.PlanRecievedDate.toLowerCase())
      );
    });
    this.setState({
      tablestate: true,
      filterdata: this.state.filterdata,
      External: true
    });
  };

  // Changing Default pagination value
  getPaginationValue = (pageSize) => {
    this.setState({
      rowsPerPage:
        pageSize == true
          ? this.state.rowsPerPage + 15
          : this.state.rowsPerPage - 15,
      newpagevalue: true,
      changepagesize: !this.state.changepagesize,
    });
  };

  render() {
    const isFilterEmpty = Object.keys(this.state.filter).every(
      (key) => !this.state.filter[key] || this.state.filter[key].length === 0
    );
     console.log(isFilterEmpty)
      console.log(this.state.headers)
    console.log("Dummytable",this.state.Dummytable)
    // this.state.Dummytable = this.state.filter;
    const tableData = this.state.Dummytable;
    let renderRows = [];
    if (this.state.tablestate == false && this.state.newpagevalue == false) {
      if (tableData && tableData[0]) {
        renderRows = tableData.map((rows, index) => {
          return rows;
        });
      }
    } else if (this.props.filterstate == false) {
      if (tableData && tableData[0]) {
        renderRows = tableData.map((rows, index) => {
          return rows;
        });
      }
    } else {
      if (tableData && tableData[0]) {
        renderRows = this.state.filterdata.map((rows, index) => {
          return rows;
        });
      }
    }

    return (
      <div key={this.state.componentKey}>
        {/* ************************************ */}
        <div className="table-responsive">
          <table className="table">
            {this.state.Dummytable !== undefined && (
              <div className="table-responsive">
                <table className="table">
                  {this.state.headers[0] && (
                    <Header
                      setFields={this.state.filter}
                      headers={this.state.headers}
                      filters={this.filters}
                      // tableData={this.state.Dummytable}
                      filtertext={this.state.TextValue}
                      tableSort={this.tableSortresult}
                    />
                  )}
                </table>
              </div>
            )}
          </table>
          {this.state.External === true && (
            <Row className="my-3 mx-1" type="flex" justify="space-between">
              <Col>
                <div className="external-search">
                  <div>
                    <span style={{ fontSize: "14px" }}>
                      <b>You can search by any value from the top by clicking on</b>
                    </span>
                    <span>
                    {!isFilterEmpty && (
                         <button
                         className="button-alluser px-3 mx-1"
                         style={{
                           opacity:
                             ((this.state.filter.Claims.length > 0 && this.state.filter.Claims.length < 4) ||
                               (this.state.filter.RenderingNPI.length > 0 && this.state.filter.RenderingNPI.length < 4))
                               ? 0.5
                               : 1,
                           cursor:
                             ((this.state.filter.Claims.length > 0 && this.state.filter.Claims.length < 4) ||
                               (this.state.filter.RenderingNPI.length > 0 && this.state.filter.RenderingNPI.length < 4) || (this.state.filter.BillingNPI.length > 0 && this.state.filter.BillingNPI.length < 4)) 
                               ? "not-allowed"
                               : "pointer",
                         }}
                         onClick={this.getGlobalClaims}
                         disabled={
                           (this.state.filter.Claims.length > 0 && this.state.filter.Claims.length < 4) ||
                           (this.state.filter.RenderingNPI.length > 0 && this.state.filter.RenderingNPI.length < 4) ||
                           (this.state.filter.BillingNPI.length > 0 && this.state.filter.BillingNPI.length < 4)
                         }
                       >
                         Search for Claims
                       </button>
                       
                        )}
                    </span>
                    {/* {this.state.isLoading && <span className="ml-2"><Spin size="small" /></span>} */}
                  </div>
                </div>
              </Col>
                <Col>
                <div className="mt-2">
                 {!isFilterEmpty && (
                  <button
                    className="delete-alluser danger pl-4 pr-4"
                    onClick={this.resetFilter}
                  >
                    Reset
                  </button>
                     )}
                </div>
              </Col>
            </Row>
          )}
          {/* table for showing rows */}
          <table className="table">
          {this.state.isLoading ? (
              // Render loader
             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40vh" }}>
                 <Spin size="large" />
             </div>
            ) : (
            this.state.Dummytable !== undefined && (
              <div className="table-responsive">
                <table className="table">
                  {this.state.Dummytable.length > 0 &&
                    this.state.Dummytable && (
                      <TableData
                          data={this.state.Dummytable}
                          header={this.state.headers}
                          tableFor="claims"
                        />
                    )}
                </table>
              </div>
          ))}
          </table>
          {/* <table className="table">
            {this.props.tableData !== undefined && (
              <div className="table-responsive">
                <table className="table">
                 

                  {this.state.headers[0] && (
                    <Header
                      headers={this.state.headers}
                      filters={this.filters}
                      // tableData={this.state.Dummytable}
                      filtertext={this.state.TextValue}
                      tableSort={this.tableSortresult}
                    />
                  )}

                 

                  {this.props.tableData.length > 0 &&
                    this.props.isTableData && (
                      <TableData
                        data={this.getpaginationData(
                          renderRows,
                          this.state.currentPage
                        )}
                        header={this.state.headers}
                      />
                    )}
                </table>
              </div>
            )}
          </table> */}

          {/* if no data is present for first time */}
          {/* {this.state.loader === false &&
            this.state.Dummytable.length === 0 && (
              <div
                style={{
                  fontSize: "20px",
                  textAlign: "center",
                  marginTop: "30vh",
                  fontWeight:"500",
                }}
              >
                Oops no data found please check the server and try reloading !
              </div>
            )} */}

         {!this.state.SearchExternal && (
          <div className="" style={{
            fontSize: "20px",
            textAlign: "center",
            marginBottom:"75px"

          }}>
            <img src={blackscreen}></img>
            <div className="my-2" >
            Enter Details and search to see the Results
            </div>
          </div> 

          )}
      
          {this.state.displayErrormessage && (
            <div
              style={{
                fontSize: "20px",
                textAlign: "center",
                marginTop: "-3vh",
                paddingTop: "164px",
                marginBottom: "155px",
              }}
            >
              {this.state.MessageForClaims
                ? this.state.MessageForClaims
                : "No results found. Please check the search criteria and try again."}
            </div>
          )}


          {/* {!this.state.isLoading && this.state.tablestate == true && this.state.filterdata.length == 0 && (
          
            <div>
              {!this.state.SearchExternal ?
                <div className="" style={{
                  fontSize: "20px",
                  textAlign: "center",

                }}>
                  <img src={globalSearch}></img>
                  <div className="my-2" >
                    Please Search for Claims
                  </div>
                </div> :
                <div
                  style={{
                    fontSize: "20px",
                    textAlign: "center",
                    marginTop: "25vh",
                    fontWeight:"500",
                  }}
                >
                  No results found.Please check the search criteria and try again.
                 
                </div>}
            </div>
          )} */}
          {/* {this.state.loader === true && (
            <div style={{ marginTop: "36vh", marginLeft: "46vw" }}>
              <Spin size="large" />
              <div style={{ marginLeft: "-6vw" }} className="search-sreen-text">
                Loading Table data...
              </div>
            </div>
          )} */}
        </div>

        <div style={{ padding: "10px 20px", justifyContent: "space-between" }}>
          <div>
            <Row>
              <Col span={12}>
                { this.state.Dummytable.length >0  &&this.state.totalPages > 15 && (
                  // This pagination will called if you are adding or removing default page size
                  <div className="">
                    {this.state.headers[0] && (
                      <Pagination
                      size="small"
                      hideOnSinglePage={true}
                      current={this.state.currentPage}
                      total={this.state.totalPages}
                      defaultPageSize="15"
                      showSizeChanger={false}
                      onChange={this.onPageChange}
                    />
                    )}
                  </div>
                )}
              </Col>

              <Col span={12} style={{ textAlign: "right" }}>
              {this.state.printclaimsloading && <Spin style={{marginRight:"20px"}} size="small" />}
                {this.state.Dummytable.length > 0 &&
                  this.state.Dummytable && (
                    <button className="button-alluser px-3 mx-1" onClick={this.exportAllClaims}>Print Claim List</button>
                  )}
              </Col>

            </Row>

          </div>
        </div>
      </div>
    );
  }
}

{
  /* Adding Redux and calling webservices Component */
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadData: (data) =>
      dispatch(
        fetchLoadData(data.url, data.method, data.key, data.headers, data.data)
      ),
    destroy: () => dispatch(unsubscribe()),
  };
};

const mapStateToProps = (state, props) => {
  const Data = state.claimsDetails;
  if (Data && Data[0]) {
    return {
      headers: Object.keys(Data[0]).map((key) => {
        console.log("key",key)
        return {
          title: key,
          displayName: Config.tableColumns[key].displayName,
          display:
            Config.tableColumns &&
              Config.tableColumns[key] &&
              Config.tableColumns[key].display
              ? true
              : false,
          filterType: Config.tableColumns[key].filterType || "text",
        };
      }),
      tableData: Data,
      loader: false,
      isTableData: state.isTableData,
    };
  } else if (state.claimsDetails === undefined && state.isTableData === false) {
    return {
      loader: false,
      isTableData: state.isTableData,
    };
  } else {
    return {
      // loader: true,
    };
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsTable);
